export const styles = theme => ({
  bar: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 90,
    background: '#ffffff',
    borderTop: '1px solid #eef0f3',
    boxShadow: '0 -4px 16px rgba(15,23,42,0.06)',
    padding: '10px 14px calc(10px + env(safe-area-inset-bottom))',
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    '@media (min-width: 720px)': {
      display: 'none'
    }
  },
  barRow: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 10
  },
  // "Not booked yet" on Book & pay (lib/unpaid-status.js barStatusText).
  barStatus: {
    margin: 0,
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 600,
    color: '#0f172a',
    textAlign: 'center'
  },
  summaryChip: {
    flex: 1,
    background: '#f8fafc',
    border: '1px solid #eef0f3',
    borderRadius: 12,
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'left',
    cursor: 'pointer',
    minWidth: 0,
    transition: 'background 0.15s ease',
    '&:active': {
      background: '#eef0f3'
    }
  },
  summaryText: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    flex: 1,
    overflow: 'hidden'
  },
  summaryPrimary: {
    fontSize: 13,
    fontWeight: 600,
    color: '#0f172a',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  summarySecondary: {
    fontSize: 12,
    color: '#37b45a',
    fontWeight: 600,
    marginTop: 2
  },
  summarySurcharges: {
    fontSize: 11,
    color: '#64748b',
    marginTop: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  summaryChevron: {
    color: '#94a3b8',
    fontSize: 20,
    flexShrink: 0,
    marginLeft: 8
  },
  nextButton: {
    background: '#37b45a',
    color: '#ffffff',
    border: 'none',
    borderRadius: 12,
    padding: '0 22px',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 15,
    fontWeight: 600,
    minWidth: 110,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    '&:active:not(:disabled)': {
      transform: 'scale(0.97)',
      background: '#2d9c4d'
    },
    '&:disabled': {
      background: '#cbd5e1',
      color: '#ffffff',
      cursor: 'not-allowed'
    }
  },
  // Step not yet complete: dimmed but still tappable (tapping reveals the
  // missing fields rather than doing nothing).
  nextButtonPending: {
    opacity: 0.6
  },
  // Drawer paper
  sheet: {
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    background: '#ffffff',
    maxHeight: '85vh',
    overflowY: 'auto',
    paddingBottom: 'env(safe-area-inset-bottom)'
  },
  sheetHandle: {
    width: 40,
    height: 4,
    borderRadius: 2,
    background: '#e2e8f0',
    margin: '10px auto 0'
  },
  sheetHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '14px 20px 4px'
  },
  sheetTitle: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 16,
    fontWeight: 600,
    color: '#0f172a'
  },
  sheetClose: {
    background: '#f1f5f9',
    border: 'none',
    borderRadius: '50%',
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#64748b'
  },
  sheetBody: {
    padding: '8px 20px 24px'
  }
})
